import '../styles/ResearchPapers/ActuarialInsightBriefs.css';

export default function ActuarialInsightBriefs() {
  const papers = [];

  return (
    <div className="rp-root">
      <div className="rp-bg" aria-hidden="true">
        <div className="rp-bg-grid" />
        <div className="rp-bg-orb rp-bg-orb--tl" />
        <div className="rp-bg-orb rp-bg-orb--br" />
      </div>

      <header className="rp-hero">
        <div className="rp-hero-inner">
          <a href="/" className="rp-back">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
            <span>Back to Home</span>
          </a>
          
          <div className="rp-meta">
            <span className="rp-tag">Research Output</span>
            <span className="rp-divider" />
            <span className="rp-date">Updated May 2025</span>
          </div>

          <h1 className="rp-title">
            <span className="rp-title-main">Actuarial Insight</span>
            <span className="rp-title-accent">Briefs</span>
          </h1>
          
          <p className="rp-lead">
            Concise, data-driven briefs delivering rapid intelligence on market 
            developments, regulatory changes, and emerging actuarial trends.
          </p>
        </div>
      </header>

      <main className="rp-body">
        {papers.length > 0 ? (
          <div className="rp-grid">
            {papers.map((paper, i) => (
              <a key={i} href={paper.pdf} className="rp-card" target="_blank" rel="noopener noreferrer">
                <div className="rp-card-accent" />
                <div className="rp-card-icon">
                  <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" /></svg>
                </div>
                <h3 className="rp-card-title">{paper.title}</h3>
                <span className="rp-card-date">{paper.date}</span>
                <span className="rp-card-action">Download PDF</span>
              </a>
            ))}
          </div>
        ) : (
          <div className="rp-empty">
            <div className="rp-empty-icon">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9v-2h2v2zm0-4H9V7h2v5z" />
              </svg>
            </div>
            <h3 className="rp-empty-title">Coming Soon</h3>
            <p className="rp-empty-text">
              Our insight briefs are being prepared by our research team. Subscribe 
              to receive the latest briefs on African insurance markets directly.
            </p>
            <div className="rp-empty-notify">
              <input type="email" placeholder="Enter your email" className="rp-empty-input" />
              <button className="rp-empty-btn">Notify Me</button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}